module.exports = __webpack_public_path__ + "static/media/logo.2d45f446.png";